import { render, staticRenderFns } from "./ItemTypesNewForm.vue?vue&type=template&id=842758d2"
import script from "./ItemTypesNewForm.vue?vue&type=script&lang=js"
export * from "./ItemTypesNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports